import React, { Fragment } from "react";
import * as AiIcons from "react-icons/ai";

// Dumm component.
const ArrowIcon = ({ value }) => {
  const iconStyle = {
    margin: "5px",
  };
  const iconStyleZero = {
    color: "rgba(255, 255, 255, 0)",
    margin: "5px",
  };
  return (
    <Fragment>
      {value > 0 ? (
        // If the value is positive.
        <AiIcons.AiOutlineArrowUp style={iconStyle} />
      ) : value < 0 ? (
        // If the value is negative.
        <AiIcons.AiOutlineArrowDown style={iconStyle} />
      ) : (
        // If the value equals to zero  we dont wont to display the arrow,
        // so his alpha color is equals to 0.
        <AiIcons.AiOutlineArrowUp style={iconStyleZero} />
      )}
    </Fragment>
  );
};    

export default ArrowIcon;
